import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { SUBCONTRACTORS_RECORDS_VIEW } from 'scenes/Permissions/constants/permissions';
import {
  selectIsAdminInSelectedProject,
  selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness,
} from 'scenes/Permissions/store/selectors/personalPermissionsSelectors';
import { setWorkSearchParams } from '../actions/demoActions';
import { selectIsPersonalWorkCalendarMode } from '../selectors/base-work-calendar.selectors';
import { selectWorkSearchStateFromDateAndToDate } from '../selectors/workSearchParamsSelectors';
import { selectIsActiveSearchFilters } from '../selectors/workSelectorsDemo';
import { loadAdminCalendarDataInTimeframeWithSearchParams } from './loadAdminCalendarDataInTimeframeWithSearchParams.thunk';
import { loadAdminCalendarFilesDataInTimeframe } from './loadAdminCalendarFilesDataInTimeframe.thunk';
import { loadAdminCalendarRecordsDataInTimeframe } from './loadAdminCalendarRecordsDataInTimeframe.thunk';
import { loadCalendarDataInTimeframe } from './loadCalendarDataInTimeframe.thunk';
import { loadSubcontractorRecordsData } from './loadSubcontractorRecordsData.thunk';
import { loadPersonalWorkCalendarData } from './my-lixani/loadPersonalWorkCalendarData.thunk';

export const searchWorkCalendar = createAsyncThunk(
  'project/searchWorkCalendar',
  async (_, { dispatch, getState }) => {
    const state = getState();
    const isAdminInSelectedProject = selectIsAdminInSelectedProject(state);

    const componentStateDates = selectWorkSearchStateFromDateAndToDate(state);

    const isPersonalWorkCalendarMode = selectIsPersonalWorkCalendarMode(state);

    const isPermissionFromActiveBusinessToViewSubcontractorRecords =
      selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness(
        getState(),
        SUBCONTRACTORS_RECORDS_VIEW
      );

    dispatch(
      setWorkSearchParams({
        fromDate: dayjs(componentStateDates.fromDate)
          .startOf('day')
          .utcOffset(0)
          .format(),
        toDate: dayjs(componentStateDates.toDate)
          .endOf('day')
          .utcOffset(0)
          .format(),
      })
    );

    const isActiveSearchFilters = selectIsActiveSearchFilters(state);

    if (isPersonalWorkCalendarMode) {
      await dispatch(loadPersonalWorkCalendarData());
    } else {
      if (isAdminInSelectedProject) {
        if (isActiveSearchFilters) {
          await dispatch(loadAdminCalendarDataInTimeframeWithSearchParams());
        } else {
          await Promise.allSettled([
            dispatch(loadAdminCalendarRecordsDataInTimeframe()),
            dispatch(loadAdminCalendarFilesDataInTimeframe()),
          ]);
        }
      } else {
        if (isPermissionFromActiveBusinessToViewSubcontractorRecords) {
          await Promise.allSettled([
            dispatch(loadCalendarDataInTimeframe()),
            dispatch(loadSubcontractorRecordsData()),
          ]);
        } else {
          await dispatch(loadCalendarDataInTimeframe());
        }
      }
    }
  }
);
